export default "__VITE_ASSET__53b33f5f__"